import { styled } from '@modules/common/components/ThemeProvider/utils';

const LinkButton = styled('button')`
  background: none !important;
  border: none;
  padding: 0 !important;

  /*optional*/
  font-family: arial, sans-serif;
  color: ${props => props.color || '#069'};
  text-decoration: underline;
  cursor: pointer;
`;

export default LinkButton;
